import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Typography,
  CircularProgress,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";
import { useConfirmEmailPassword } from "@/hooks";

export const ConfirmEmailPage = () => {
  const confirmedRef = useRef(false);
  const { confirmEmail, data, error, loading } = useConfirmEmailPassword();

  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");

  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    severity: "success" | "error";
    message: string;
  }>({
    open: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    if (!email || !token || confirmedRef.current) return;

    confirmEmail({ email, token });
    confirmedRef.current = true;
  }, [email, token, confirmEmail]);

  useEffect(() => {
    if (data?.message) {
      setSnackbar({
        open: true,
        severity:
          data.message === "Email confirmed successfully."
            ? "success"
            : "error",
        message: data.message,
      });
    }
  }, [data]);

  useEffect(() => {
    if (data?.message === "Email confirmed successfully.") {
      const timer = setTimeout(() => {
        window.location.href = "/profile";
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        severity: "error",
        message: error,
      });
    }
  }, [error]);

  return (
    <Box sx={{ mt: 4, textAlign: "center" }}>
      {loading && <CircularProgress />}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Typography variant="h5" mt={2}>
        {data?.success ? "Redirecting..." : "Email Confirmation"}
      </Typography>
    </Box>
  );
};
